<template>
	<div class="messages d-flex flex-column-reverse align-center">
		<div style="width: 100%">
			<div class="d-flex flex-column">
				<div
					dense
					color="transparent"
					class="d-flex flex-column">
					<div
						v-for="(message, i) in messages"
						:key="i"
						class="px-0 mb-2">
						<message :message="message"></message>
					</div>
				</div>
				<div
					height="150"
					class="px-2 white text-area message-input"
				>
					<div
						class="d-flex pt-2"
						style="width: 100%"
					>
						<div class="ml-2 d-flex justify-center align-center flex-grow-1">
							<input
								type="file"
								ref="fileInput"
								@change="onFileChange"
								accept="image/*"
								style="display: none" />

								<v-textarea
									v-model="message"
									label="الرسالة"
									outlined
									dense
									hide-details
									:rows="3"
									auto-grow
									no-resize
									class="rounded-lg"
									:append-icon="message || image ? '' : 'mdi-paperclip'"
									@click:append="
										!message && $refs.fileInput.click()
									"
									:readonly="!!imagePreview"
								>
									<template v-slot:prepend-inner>
										<div
											v-if="imagePreview"
											class="d-flex align-center mr-2">
											<v-img
												:src="imagePreview"
												width="40"
												height="40"
												class="mb-1 rounded"></v-img>
											<v-btn
												icon
												small
												@click="clearImage">
												<v-icon small
													>mdi-close</v-icon
												>
											</v-btn>
										</div>
									</template>
								</v-textarea>
								<v-checkbox
									v-if="false"
									dense
									hide-details
									label="مرسل من قبل ولي الأمر"
									v-model="isParent">
								</v-checkbox>

								<div>
							<v-btn
								:loading="loading"
								:disabled="loading || (!message && !image)"
								@click="sendMessage"
								class="py-4 ms-2 rounded-lg"
								color="primary">
								<v-icon class="send-icon text-h5">
									mdi-send-variant
								</v-icon>
							</v-btn>
						</div>
						</div>
					</div>
					<!-- <div
						class="d-flex pt-2"
						style="width: 100%">
						<div class="ml-2 flex-grow-1">
							<v-textarea
								v-model="message"
								label="الرسالة"
								outlined
								dense
								hide-details
								:rows="3"
								auto-grow
								no-resize
								class="rounded-lg"
							>
								<template v-slot:append>
									<input
										type="file"
										ref="fileInput"
										@change="onFileChange"
										accept="image/*"
										style="display: none" 
									/>
									<v-btn
										icon
										@click="$refs.fileInput.click()"
										class="py-4">
										<v-icon class="text-h5">mdi-paperclip</v-icon>
									</v-btn>
								</template>
							</v-textarea>
							<v-checkbox
								v-if="false"
								dense
								hide-details
								label="مرسل من قبل ولي الأمر"
								v-model="isParent"></v-checkbox>
						</div>
						<div>
							<v-btn
								:loading="loading"
								:disabled="loading"
								@click="sendMessage"
								class="py-4"
								color="primary">
								<v-icon class="send-icon text-h5">
									mdi-send-variant
								</v-icon>
							</v-btn>
						</div>
					</div> -->

					<p
						class="mb-2 mt-3 px-2"
						v-if="false">
						يتم الرد على الرسائل خلال يومي عمل ضمن أوقات الدوام
						الرسمي
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Message from '@/components/Message.vue';

export default {
	name: 'Chat',

	components: { Message },

	props: ['messages', 'student'],

	data() {
		return {
			message: null,
			isParent: false,

			internalLoading: false,
			image: null,
			imagePreview: null,
			loading: false
		};
	},

	methods: {
		onFileChange(e) {
			const file = e.target.files[0];
			if (file) {
				this.image = file;
				this.imagePreview = URL.createObjectURL(file);
			}
		},
		clearImage() {
			this.image = null;
			this.imagePreview = null;
			this.$refs.fileInput.value = null;
		},

		sendMessage() {
			this.internalLoading  = true;
			const formData = new FormData();
			formData.append('Content', this.message || '');
			formData.append('StudentId', this.student.StudentId);
			formData.append('StudentUserName', this.student.StudentUserName);
			formData.append('CourseName', this.student.CourseName);
			if (this.image) {
				formData.append('image', this.image);
			}
			this.$store
				.dispatch('student/sendMessage', formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				})
				.then(() => {
					this.message = null;
					this.clearImage();
					this.$emit('update');
				})
				.finally(() => {
					this.internalLoading = false;
				});
		},
	},
};
</script>

<style lang="scss" scoped>
.send-icon {
	transform: scale(-1);
}
.messages {
	padding-top: 10px;
	height: calc(100vh - 180px);
	overflow-y: scroll;
}
.message-input {
	position: sticky;
	bottom: 0;
}
</style>
